import L from "leaflet";

L.DomEvent.fakeStop = function () {};

export {};
